import { Link } from "react-router-dom";
import { PublicLayout } from "../../components/PublicLayout";

/** Gemeinsames Gerüst für die Ratgeber-Seiten (SEO-Einstiege). */
export function GuideLayout({
  eyebrow,
  title,
  intro,
  children,
}: {
  eyebrow: string;
  title: string;
  intro: string;
  children: React.ReactNode;
}) {
  return (
    <PublicLayout>
      <article className="mx-auto max-w-[760px] px-6 pt-14 pb-20 text-[#211019]">
        <div className="font-mono text-[12.5px] tracking-[0.14em] uppercase text-brand-600 font-semibold">{eyebrow}</div>
        <h1 className="font-display font-medium text-[clamp(32px,5vw,46px)] leading-[1.08] tracking-[-0.018em] mt-3 text-balance">{title}</h1>
        <p className="mt-5 text-[18px] leading-relaxed text-[#5C4D55]">{intro}</p>
        <div className="guide mt-10">{children}</div>
        <div className="mt-14 rounded-[22px] bg-gradient-to-br from-brand-600 to-brand-800 px-8 py-8 text-white">
          <div className="font-display text-[26px] font-medium leading-tight">Vorsorgen kostet weniger als Suchen</div>
          <p className="mt-2 text-[15.5px] leading-relaxed text-[#F6E2F4]">
            Mit petloc trägt dein Tier einen QR-Code, den jeder Finder mit dem Handy scannt. Du bekommst Standort und Nachricht sofort, ohne dass deine Nummer öffentlich ist. Halsband ab 10 €, Mini-Anhänger fürs vorhandene Halsband ab 10 €, kein Abo.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link to="/signup" className="bg-white text-brand-800 font-semibold rounded-[14px] px-5 py-3 text-[15px] no-underline">Kostenlos Konto anlegen</Link>
            <Link to="/#produkt" className="text-white bg-white/[0.14] border border-white/35 font-semibold rounded-[14px] px-5 py-3 text-[15px] no-underline">Halsband ansehen</Link>
          </div>
        </div>
      </article>
    </PublicLayout>
  );
}

export function H2({ children }: { children: React.ReactNode }) {
  return <h2 className="font-display font-medium text-[28px] leading-tight tracking-[-0.01em] mt-10 mb-3">{children}</h2>;
}
export function P({ children }: { children: React.ReactNode }) {
  return <p className="text-[16.5px] leading-relaxed text-[#3E2F37] mb-4">{children}</p>;
}
export function Check({ items }: { items: React.ReactNode[] }) {
  return (
    <ul className="grid gap-2.5 mb-5">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-3 bg-white border border-[#ECE3E7] rounded-2xl px-4 py-3.5 text-[15.5px] leading-relaxed text-[#2E2027]">
          <span className="shrink-0 text-brand-600 text-lg leading-none mt-0.5">✓</span>
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}
